import React, { Component } from 'react';
import GenderSelector from './GenderSelector';
import AgeSelector from './AgeSelector';
import YearSlider from './YearSlider';
import { Row, Col, Icon } from 'react-materialize';
import CountryTags from './CountryTags';
import { connect } from 'react-redux';


class OpenCollapsible extends Component {
  constructor(props){
    super(props);
    this.state = {
      displayYears: false,
      years: null
    }
    this.onHoverDisplayYears = this.onHoverDisplayYears.bind(this);
    this.onLeaveDisplayYears = this.onLeaveDisplayYears.bind(this);
  }

  onHoverDisplayYears( years ){
    this.setState({ displayYears: true, years: years })
  }

  onLeaveDisplayYears() {
    this.setState({ displayYears: false })
  }
  render() {
    const { countries,
            display,
            allAge,
            countryToolTip,
            onClickCollapsible = ()  => {},
            onClearFilter = () => {},
            onCloseCountryToolTip = () => {}} = this.props;
    //const { age } = this.state;
    if(display === "phone"){
      return (
        <div>
          <Row className="countries-selected left-align" style={{marginTop: "20px"}}>
            {countries.map(country =>
              <CountryTags
                onHoverDisplayYears={this.onHoverDisplayYears}
                onLeaveDisplayYears={this.onLeaveDisplayYears}
                country={country}
                key={country}/>
              )}
            </Row>
            <Row>
               {this.state.displayYears && <div className="tooltiptext-years">{this.state.years}</div>}
            </Row>
            <Row className="left-align">
              <div>
                Gender
              </div>
              <div style={{width:"200px"}}>
                {/* <GenderSelector
                  onClickGender={onClickGender}
                  gender={gender}/> */}
                  <GenderSelector />
              </div>
            </Row>
            <Row className="left-align">
              <div>
                Year Range
              </div>
              <div style={{width:"100px"}}>
                  <YearSlider />
              </div>
            </Row>
            <Row className="left-align" style={{height: "100%"}}>
              <div>
                Age
              </div>
              <div style={{width:"100px"}}>
                <AgeSelector />
                {/* <AgeSelector age={age} onChangeAge={onChangeAge} /> */}
              </div>
            </Row>
        </div>
      )
    } else {
      return (
        <div className="OpenCollapsible">
          <Row>
            <Col s={2} style={{ paddingTop: "2px", paddingLeft: "5%"}}>
              <Row className="header-title">
                Gender
              </Row>
              <Row style={{marginTop: "20px"}}>
                  <GenderSelector />
              </Row>
            </Col>
            <Col style={{ paddingTop: "2px", paddingLeft: "5%"}} s={2}>
              <Row className="header-title">
              Age
              </Row>
              <Row className="" style={{marginTop: "20px"}}>
                <AgeSelector/>
              </Row>
            </Col>
            <Col s={3} className="">
              <Row className="header-title">
                  Year Range
              </Row>
              <Row s={12} className="" style={{marginTop: "20px"}}>
                <YearSlider />
              </Row>
            </Col>
            <Col s={4} className="" >
            {
                countryToolTip?(
                  <div>
                    <div className="tool-tip-country">
                      <div className="tooltip-text">
                        <div style={{fontWeight: 'bold', display:'flex', justifyContent: 'space-between', alignSelf: 'center'}}>
                            <span>TIP</span>
                            <span style={{ cursor: 'pointer'}} onClick={onCloseCountryToolTip}>x</span>
                        </div>
                        <span>Use the dropdown menu to select individual countries (maximum of 10).</span>
                        </div>
                      </div>
                    </div>):""
              }
              <Row className="header-title">
              Countries Selected
              </Row>
              <Row className="countries-selected" style={{marginTop: "20px"}}>
                {countries.map(country =>
                  <CountryTags onHoverDisplayYears={this.onHoverDisplayYears}
                               onLeaveDisplayYears={this.onLeaveDisplayYears}
                               country={country}
                               key={country}/>
                )}
              </Row>
              <Row>
                 {this.state.displayYears && <div className="tooltiptext-years">{this.state.years}</div>}
              </Row>
            </Col>
            <Col onClick={onClearFilter} s={1}
                  className="clear-filters">
              <Icon>replay</Icon><br/>
              <span>Clear Filters</span>
            </Col>
          </Row>
          <div className="collape">
            <div className="rectangle" onClick={onClickCollapsible}>
            <Icon>keyboard_arrow_up</Icon>
            </div>
          </div>
        </div>
      );
    }
  }
}

function mapStateToProps(state){
  return {
    countries: state.countries,
    all: state.all,
    countryToolTip: state.countryToolTip
  }
};

function mapDispatchToProps(dispatch){
  return {
    onClearFilter: () => dispatch({ type: 'CLEARFILTER' }),
    onCloseCountryToolTip: ()=> dispatch({ type: 'ONCLOSECOUNTRYTOOLTIP'})
    //onChangeAge: () => dispatch({ type: 'ADDNOTES' }),
    //  addPhotos: (photos) => dispatch({ type: 'ADDPHOTOS', value: photos})
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OpenCollapsible);



// WEBPACK FOOTER //
// ./src/components/OpenCollapsible.js